"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInvoiceMetricsParams = void 0;
const createInvoiceMetricsParams = () => {
    // currently no params required. can extend as needed.
    return {
        isValid: true,
        params: null,
    };
};
exports.createInvoiceMetricsParams = createInvoiceMetricsParams;
//# sourceMappingURL=invoiceMetricsParams.js.map